import React from "react";

import { SectionsModels } from "../../../../../models/SectionsModels";
import { DataTable, DataTableColumn } from "../../../../../components/Admin";
import { DangerButton } from "../../../../_layout/AdminLayout.styles";

interface SectionTable {
  data: SectionsModels[];
  onDelete: (section: SectionsModels) => void;
  deletingId: string;
}

const SectionsTable: React.FC<SectionTable> = ({
  data,
  onDelete,
  deletingId,
}) => {
  const columns: DataTableColumn<SectionsModels>[] = [
    {
      key: "position",
      header: "Posição",
      width: "120px",
      render: (section) => section.position ?? "—",
    },
    {
      key: "title",
      header: "Título da Seção",
      align: "start",
      render: (section) => <strong>{section.title}</strong>,
    },
    {
      key: "actions",
      header: "Ações",
      width: "160px",
      render: (section) => (
        <DangerButton
          type="button"
          onClick={() => onDelete(section)}
          disabled={!!deletingId || !section.schoolid_sectionid}
          aria-label={`Excluir a seção ${section.title}`}
        >
          {deletingId && deletingId === section.schoolid_sectionid
            ? "Excluindo..."
            : "Excluir"}
        </DangerButton>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={data}
      rowKey={(section) => section.schoolid_sectionid ?? section.sectionid}
      emptyMessage="Nenhuma seção encontrada."
    />
  );
};

export default SectionsTable;
